import { render, staticRenderFns } from "./EducationalItemInfoForm.vue?vue&type=template&id=2fe10ea5&"
import script from "./EducationalItemInfoForm.vue?vue&type=script&lang=js&"
export * from "./EducationalItemInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports